import { render, staticRenderFns } from "./protocol.vue?vue&type=template&id=7a448745&scoped=true&"
import script from "./protocol.vue?vue&type=script&lang=js&"
export * from "./protocol.vue?vue&type=script&lang=js&"
import style0 from "./protocol.vue?vue&type=style&index=0&id=7a448745&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a448745",
  null
  
)

export default component.exports